import { FileDropZone, ImportErrors } from "web/components"
import { Select } from "web/components/Form/Controls"
import { useState, useEffect } from "react"
import { isNonEmptyArray } from "web/services/helpers"
import { generatePath, useHistory } from "react-router-dom"

import useImports from "web/hooks/data/imports/useImports"
import ImportsList from "./ImportsList"

export default function ImportsInterface({
  types = [],
  deprecatedTypes = [],
  showUrl,
}) {
  const [typeSelect, setTypeSelect] = useState()
  const [waiting, setWaiting] = useState(false)
  const [isUploading, setIsUploading] = useState(false)
  const [errors, setErrors] = useState([])
  const history = useHistory()

  const imports = useImports({
    type: typeSelect?.value,
    swrOptions: {
      refreshInterval: waiting ? 5000 : 0,
    },
  })

  const updating = isNonEmptyArray(
    imports.filter((importObj) => importObj.doing_work)
  )

  async function changeImportType(typeSelect) {
    setTypeSelect(typeSelect)
  }

  useEffect(() => {
    if (waiting && !updating) {
      setWaiting(false)
    }
    if (!waiting && updating) {
      setWaiting(true)
    }
  }, [waiting, updating])

  useEffect(() => {
    if (history?.location?.state) {
      setTypeSelect({
        value: history.location.state.value,
        label: history.location.state.label,
      })
    }
  }, [history])

  async function handleFilesSelected(files) {
    setIsUploading(true)
    const currentLocation = window.location.pathname
    const formData = new FormData()

    formData.append("file", files[0])
    formData.append("type", typeSelect.value)
    imports
      .add(formData)
      .then((importObj) => {
        if (currentLocation === window.location.pathname) {
          window.Turbo.visit(generatePath(showUrl, { id: importObj.id }))
        }
      })
      .catch((result) => {
        setErrors(result.response.data.errors)
        setIsUploading(false)
      })
  }

  const completeListOfImportTypes = [
    { value: "asset", label: "Asset" },
    { value: "company", label: "Company" },
    { value: "contact", label: "Contact" },
    { value: "deal", label: "Deal" },
    { value: "comparable_deal", label: "Comparable Deal" },
    { value: "sale", label: "Sale" },
    { value: "deal_asset", label: "Deal Asset" },
    { value: "pipeline_deal", label: "Pipeline Deal" },
    { value: "portfolio", label: "Portfolio" },
    { value: "deal_portfolio_allocation", label: "Deal Portfolio Allocation" },
    { value: "admin_comparable_deal", label: "Comparable Deal" },
    { value: "activity", label: "Activity" },
  ]

  const importTypes = completeListOfImportTypes
    .filter((import_type) => {
      return types.includes(import_type.value)
    })
    .map((import_type) => {
      if (deprecatedTypes.includes(import_type.value)) {
        return { ...import_type, label: `${import_type.label} (Deprecated)` }
      }
      return import_type
    })

  const canUpload = typeSelect && !deprecatedTypes.includes(typeSelect.value)

  return (
    <div>
      <h2 className="text-2xl">Import Data</h2>
      <div className="margin-b-m mt-4 rounded-md border border-neutral-9 bg-white p-5">
        <Select
          onChange={changeImportType}
          value={typeSelect}
          options={importTypes}
          label="Type of Import"
        />
        <div className="mt-4">
          <ImportErrors errors={errors} />
        </div>
        {canUpload && (
          <div className="mt-4 h-72">
            <FileDropZone
              disabled={isUploading}
              onFilesDropped={handleFilesSelected}
              acceptFileTypes=".csv"
            />
          </div>
        )}
      </div>
      {typeSelect && (
        <div className="mt-4">
          <ImportsList
            kind={typeSelect.label}
            imports={imports}
            showUrl={showUrl}
          />
        </div>
      )}
    </div>
  )
}
